// Pages pass their `setNotifObj` down through the controller into the api module, which
// hands it to FetchRequest. Six api modules still use the older singleton form
// `new FetchRequest(`${host}`)` and pass a base url string instead of a setter, so their
// failures could never reach a toast. NotifyProvider registers the app wide setter here
// once and those modules fall back to it.

import type { NotifyObj, NotifyType, Notifier } from "types/notify";

let fallbackNotifier: Notifier | null = null;

export const registerNotifier = (setNotifObj: Notifier | null | undefined): void => {
  fallbackNotifier = typeof setNotifObj === "function" ? setNotifObj : null;
};

export const getNotifier = (): Notifier | null => fallbackNotifier;

// `own` is the setter the calling page supplied, if it supplied one.
export const notifyWith = (own: Notifier | null, type: NotifyType, text?: string): void => {
  const setNotifObj = own || fallbackNotifier;

  if (!setNotifObj) return;

  const next: NotifyObj = { show: true, type: type, text: text };

  setNotifObj(next);
};
